import React from "react"
import { Link } from "gatsby"

export const AbatLOiseau: React.FC = () => (
  <div>
    <h3>Abat-l'oiseau Régional.</h3>

    <p>
      <ul>
        <li>
          À partir de la saison 2025-2026, le CRTA Grand Est propose un Tir du Roy régional sous la forme d'un "Abat l'oiseau" (tir vertical).
        </li>

        <li>
          Vous trouverez ci-dessus le règlement ainsi que le mandat du tir qui se déroulera cette année le 14 mai à Colombey-les-Belles (54).
        </li>
      </ul>
    </p>
  </div>
)
